import React, { Component, ComponentProps } from 'react';
import { withTranslation } from 'react-i18next';
import { Error } from '../Error/Error';

type ErrorBoundaryComponentProps = ComponentProps<any>;

type ErrorBoundaryState = {
  hasError: boolean;
  error: string;
};

class ErrorBoundary extends Component<ErrorBoundaryComponentProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryComponentProps) {
    super(props);

    this.state = {
      hasError: false,
      error: '',
    };
  }

  componentDidCatch(error: Error): void {
    this.setState({ hasError: true, error: error.message });
  }

  render() {
    const { children, t } = this.props;
    const { hasError, error } = this.state;

    if (hasError) {
      return (
        <div>
          <Error error={{ message: t('errorBoundary.error') }} />
          <Error error={{ message: error }} />
        </div>
      );
    }
    return children;
  }
}

export default withTranslation()(ErrorBoundary);
